import { useDeleteSupplierModalTranslations } from "@app/screens/Supplier/Suppliers/components/DeleteSupplierModal/i18n";
import { Tooltip } from "@design-system/DataDisplay/Tooltip";
import { Modal } from "@design-system/Modal";
import { Text } from "@design-system/Typography/Text";
import { type FC } from "react";

export const DeleteSupplierModal: FC<{
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onDelete: () => void;
    supplierCount?: number;
    disabled?: boolean;
    disabledTooltip?: string;
}> = ({
    open,
    onOpenChange,
    onDelete,
    supplierCount = 1,
    disabled,
    disabledTooltip,
}) => {
    const { t, keys } = useDeleteSupplierModalTranslations();

    return (
        <Modal open={open} onOpenChange={onOpenChange}>
            <Modal.Overlay centerContent>
                <Modal.Content>
                    <Modal.Header>
                        <Modal.Title>
                            {t(keys.delete_supplier_modal_title, {
                                count: supplierCount,
                            })}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Text variant="body" color="primary">
                            {t(keys.delete_supplier_modal_body, {
                                count: supplierCount,
                            })}
                        </Text>
                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.CancelCTA>
                            {t(keys.delete_supplier_modal_cancel_button)}
                        </Modal.CancelCTA>
                        <Tooltip>
                            <Tooltip.Trigger>
                                <div>
                                    <Modal.ConfirmCTA
                                        variant="flatDanger"
                                        onClick={onDelete}
                                        disabled={disabled}
                                    >
                                        {t(
                                            keys.delete_supplier_modal_confirm_button,
                                        )}
                                    </Modal.ConfirmCTA>
                                </div>
                            </Tooltip.Trigger>
                            {disabled && !!disabledTooltip && (
                                <Tooltip.Content>
                                    {disabledTooltip}
                                </Tooltip.Content>
                            )}
                        </Tooltip>
                    </Modal.Footer>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};
